import * as React from "react";
import { MProductTagBox, MProductTagWrap, MProductTagtab } from "./styles";
import throttle from "../../../../utils/throttle";
const activeTabStyle = (lightColor = "#fff", backgroundColor = "#ff5a00") => {
    return {
        color: lightColor,
        backgroundColor,
    };
};
const defaultTabStyle = (color = "#333") => {
    return {
        color,
    };
};
export default function MProductTag(props) {
    var _a;
    const { tagGroup, stickToTop = 0 } = props;
    const [activeTab, changeActiveTab] = React.useState(props.activeTab);
    const [isFixed, setTabPostition] = React.useState(false);
    React.useEffect(() => {
        changeActiveTab(props.activeTab);
    }, [props.activeTab]);
    React.useEffect(() => {
        if (props.canScrollFixed) {
            window.addEventListener("scroll", throttle(onScroll, 30));
        }
        return () => {
            window.removeEventListener("scroll", onScroll);
        };
    }, [props.clientElement]);
    const tabClick = (item, index) => {
        changeActiveTab(item.id);
        props.onClick(item.id, index);
        const { clientElement } = props;
        if (!clientElement) {
            return;
        }
        const currentElementRect = clientElement === null || clientElement === void 0 ? void 0 : clientElement.getBoundingClientRect();
        const scrollTop = window.scrollY || window.pageYOffset;
        const condition = scrollTop > (clientElement === null || clientElement === void 0 ? void 0 : clientElement.offsetTop) - props.stickToTop &&
            scrollTop < (clientElement === null || clientElement === void 0 ? void 0 : clientElement.offsetTop) + (currentElementRect === null || currentElementRect === void 0 ? void 0 : currentElementRect.height);
        if (isFixed && condition) {
            window.scrollTo(0, Math.max(0, (clientElement === null || clientElement === void 0 ? void 0 : clientElement.offsetTop) - props.stickToTop));
        }
    };
    const onScroll = (event) => {
        var _a;
        const target = event.target;
        const scrollTop = ((_a = target === null || target === void 0 ? void 0 : target.documentElement) === null || _a === void 0 ? void 0 : _a.scrollTop) || window.scrollY || window.pageYOffset;
        const { clientElement } = props;
        if (!clientElement) {
            return;
        }
        const currentElementRect = clientElement === null || clientElement === void 0 ? void 0 : clientElement.getBoundingClientRect();
        const condition = scrollTop >= (clientElement === null || clientElement === void 0 ? void 0 : clientElement.offsetTop) - props.stickToTop &&
            scrollTop < (clientElement === null || clientElement === void 0 ? void 0 : clientElement.offsetTop) + (currentElementRect === null || currentElementRect === void 0 ? void 0 : currentElementRect.height);
        if (condition) {
            setTabPostition(true);
        }
        else {
            setTabPostition(false);
        }
    };
    const nextActiveTab = activeTab || ((_a = props.tagGroup[0]) === null || _a === void 0 ? void 0 : _a.id) || "";
    return (React.createElement(MProductTagWrap, null,
        React.createElement(MProductTagBox, { style: { backgroundColor: tagGroup[0].bgColor || "#fff" }, isFixed: isFixed, scrollTop: stickToTop }, tagGroup.map((item, index) => (React.createElement(MProductTagtab, { key: item.positionId, "data-key": item.positionId, onClick: () => tabClick(item, index), style: `${nextActiveTab}` === item.id
                ? activeTabStyle(item.text.lightColor, item.focusBgColor)
                : defaultTabStyle(item.text.color) }, item.text.content))))));
}
